<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" label-position="right" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="Category3" prop="category3Code">
                    <el-select v-model="queryCondition.category3Code" clearable placeholder="请选择" style="width:100%">
                      <el-option :key="index" v-for="(item,index) in category3CodeOptions" :label="item.object" :value="item.key"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Sponsor" prop="sponsorName">
                    <el-input v-model="queryCondition.sponsorName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="ASL Group" prop="aslGroupName">
                    <el-input v-model="queryCondition.aslGroupName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="农场名称" prop="farmName">
                    <el-input v-model="queryCondition.farmName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="农场代码" prop="farmCode">
                      <el-input v-model="queryCondition.farmCode" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="养殖场性质" prop="farmNature">
                      <el-select v-model="queryCondition.farmNature" clearable placeholder="请选择" style="width:100%">
                        <el-option :key="index" v-for="(item,index) in farmNatureOptions" :label="item.object" :value="item.key"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="是否有备案" prop="isInspected">
                      <el-select v-model="queryCondition.isInspected" clearable placeholder="请选择" style="width:100%">
                        <el-option :key="index" v-for="(item,index) in isInspectedOptions" :label="item.object" :value="item.key"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="养殖模式" prop="breedingMode">
                      <el-select v-model="queryCondition.breedingMode" clearable placeholder="请选择" style="width:100%">
                        <el-option :key="index" v-for="(item,index) in breedingModeOptions" :label="item.object" :value="item.key"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="农场状态" prop="farmStatus">
                      <el-select v-model="queryCondition.farmStatus" clearable placeholder="请选择" style="width:100%">
                        <el-option :key="index" v-for="(item,index) in farmStatusOptions" :label="item.object" :value="item.key"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="审批状态" prop="auditStatus">
                      <el-select v-model="queryCondition.auditStatus" clearable placeholder="请选择" style="width:100%">
                        <el-option :key="index" v-for="(item,index) in auditStatusOptions" :label="item.object" :value="item.key"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="small" class="btn" type="primary" @click="onAdd" v-acl="RMC_PROT_FARM_ADD" v-if="ms_roles.indexOf('QSPI_RMC_CHICK_SPONS_SUPP')!==-1||ms_roles.indexOf('QSPI_RMC_PORK_SPONS_SUPP')!==-1">新增</el-button>
        <el-button size="small" class="btn" type="danger" @click="onDel" v-acl="RMC_PROT_FARM_DELETE" v-if="ms_roles.indexOf('QSPI_RMC_CHICK_SPONS_SUPP')!==-1||ms_roles.indexOf('QSPI_RMC_PORK_SPONS_SUPP')!==-1">删除</el-button>
        <el-button size="small" class="btn" type="primary" @click="onSubmit" v-acl="RMC_PROT_FARM_SUBMIT" v-if="ms_roles.indexOf('QSPI_RMC_CHICK_SPONS_SUPP')!==-1||ms_roles.indexOf('QSPI_RMC_PORK_SPONS_SUPP')!==-1">提交</el-button>
        <el-button size="small" class="btn" type="primary" @click="onVerificationAudit" v-acl="RMC_PROT_FARM_AUDIT" v-if="ms_roles.indexOf('QSPI_RMC_CHICK_SPONS_SUPP')!==-1||ms_roles.indexOf('QSPI_RMC_PORK_SPONS_SUPP')!==-1">验证审核维护</el-button>
        <el-button size="small" class="btn" type="primary" @click="onApprove" v-acl="RMC_PROT_FARM_APPROVE" v-if="ms_roles.indexOf('QSPI_RMC_PROTEIN_CQS')!==-1">批准</el-button>
        <el-button size="small" class="btn" type="primary" @click="onReturn" v-acl="RMC_PROT_FARM_RETURN" v-if="ms_roles.indexOf('QSPI_RMC_PROTEIN_CQS')!==-1">退回</el-button>
        <el-button size="small" class="btn" type="primary" @click="confirmIsUpdate" v-acl="RMC_PROT_FARM_CONFIRM" v-if="ms_roles.indexOf('QSPI_RMC_CHICK_SPONS_SUPP')!==-1||ms_roles.indexOf('QSPI_RMC_PORK_SPONS_SUPP')!==-1">确认无更新</el-button>
        <el-dropdown split-button type="primary" placement="bottom" v-acl="RMC_PROT_FARM_REPORT,RMC_PROT_FARM_REPORT_QUR">
          报表导出
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <el-button class="dropdownItemBtn" size="mini" type="primary" @click="downloadFarm" v-acl="RMC_PROT_FARM_REPORT">农场清单</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-button class="dropdownItemBtn" size="mini" type="primary" @click="downloadFarmQuarter" v-acl="RMC_PROT_FARM_REPORT_QUR">农场清单季度</el-button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown split-button type="primary" placement="bottom" v-acl="RMC_PROT_FARM_IMPORT,RMC_PROT_FARM_IMPORT_AUDIT" v-if="ms_roles.indexOf('QSPI_RMC_CHICK_SPONS_SUPP')!==-1||ms_roles.indexOf('QSPI_RMC_PORK_SPONS_SUPP')!==-1">
          批量导入
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-acl="RMC_PROT_FARM_IMPORT" v-if="ms_roles.indexOf('QSPI_RMC_CHICK_SPONS_SUPP')!==-1||ms_roles.indexOf('QSPI_RMC_PORK_SPONS_SUPP')!==-1">
              <el-button class="dropdownItemBtn" size="mini" type="primary" @click="onBatchUpload">农场清单</el-button>
            </el-dropdown-item>
            <el-dropdown-item v-acl="RMC_PROT_FARM_IMPORT_AUDIT" v-if="ms_roles.indexOf('QSPI_RMC_CHICK_SPONS_SUPP')!==-1||ms_roles.indexOf('QSPI_RMC_PORK_SPONS_SUPP')!==-1">
              <!-- <el-upload class="dropdownItemBtn" ref="upload1" :headers="header" :action="uploadUrl1" accept=".xls,.xlsx" :on-error="uploadError" :on-success="uploadSuccess1" :before-upload="beforeUpload1" :file-list="fileList1" :limit="1" :auto-upload="true" :show-file-list="false">
                <el-button size="mini" type="primary">验证审核时间/结果</el-button>
              </el-upload> -->
              <el-button class="dropdownItemBtn" size="mini" type="primary" @click="onBatchUploadVertify">验证审核时间/结果</el-button>
            </el-dropdown-item>
            <el-dropdown-item v-acl="RMC_PROT_FARM_IMPORT_AUDIT" v-if="ms_roles.indexOf('QSPI_RMC_CHICK_SPONS_SUPP')!==-1||ms_roles.indexOf('QSPI_RMC_PORK_SPONS_SUPP')!==-1">
              <el-upload class="dropdownItemBtn" ref="upload2" :headers="header" :action="uploadUrl2" :on-error="uploadError" :on-success="uploadSuccess2" :before-upload="beforeUpload2" :file-list="fileList2" :limit="1" :auto-upload="true" :show-file-list="false">
                <el-button size="mini" type="primary">验证审核报告附件</el-button>
              </el-upload>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button size="small" class="btn" type="primary" @click="onUpdateLog" v-acl="RMC_PROT_FARM_CHANGE_LOG" v-if="ms_roles.indexOf('QSPI_RMC_PROTEIN_CQS')!==-1">更新日志</el-button>
        <el-button size="small" class="btn" type="primary" @click="downloadAuditReport" v-acl="RMC_PROT_FARM_AUDIT_DOWNLOAD" v-if="ms_roles.indexOf('QSPI_RMC_PROTEIN_CQS')!==-1">审核报告下载</el-button>
      </el-row>
      <el-table ref="plxTable" :data="tableData" @selection-change="selectionChange" border stripe max-height="600" highlight-current-row>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column align="center" label="Category3" show-overflow-tooltip min-width="100" prop="category3Name" fixed="left"></el-table-column>
        <el-table-column align="center" label="Sponsor" show-overflow-tooltip min-width="90" prop="sponsorName" fixed="left"></el-table-column>
        <el-table-column align="center" label="ASL Group" show-overflow-tooltip min-width="120" prop="aslGroupName" fixed="left"></el-table-column>
        <el-table-column align="center" label="农场代码" show-overflow-tooltip min-width="120" prop="farmCode" fixed="left"></el-table-column>
        <el-table-column align="center" label="农场名称" show-overflow-tooltip min-width="100" prop="farmName" fixed="left">
          <template slot-scope="scope">
            <el-button type="text" @click="onDetail(scope.row)">{{scope.row.farmName}}</el-button>
          </template>
        </el-table-column>
        <el-table-column align="center" label="追溯代码" show-overflow-tooltip min-width="90" prop="traceCode"></el-table-column>
        <el-table-column align="center" label="地址" show-overflow-tooltip min-width="90" prop="farmAddress"></el-table-column>
        <el-table-column align="center" label="舍数" show-overflow-tooltip min-width="90" prop="numOfHouse"></el-table-column>
        <el-table-column align="center" label="养殖量/栋(万只)" show-overflow-tooltip min-width="120" prop="breedingQuantityPerHouse"></el-table-column>
        <el-table-column align="center" label="批出栏量(万只)" show-overflow-tooltip min-width="120" prop="slaughterVolumePerBatch"></el-table-column>
        <el-table-column align="center" label="年出栏量(万只)" show-overflow-tooltip min-width="120" prop="slaughterVolumePerYear"></el-table-column>
        <el-table-column align="center" label="养殖场性质" show-overflow-tooltip min-width="90" prop="farmNatureView"></el-table-column>
        <el-table-column align="center" label="是否有备案" show-overflow-tooltip min-width="90" prop="isInspected"></el-table-column>
        <el-table-column align="center" label="商检局备案号" show-overflow-tooltip min-width="120" prop="inspectionNo"></el-table-column>
        <el-table-column align="center" label="场长" show-overflow-tooltip min-width="90" prop="farmDirector"></el-table-column>
        <el-table-column align="center" label="联系电话" show-overflow-tooltip min-width="90" prop="phoneNo"></el-table-column>
        <el-table-column align="center" label="养殖模式" show-overflow-tooltip min-width="90" prop="breedingModeView"></el-table-column>
        <el-table-column align="center" label="农场状态" show-overflow-tooltip min-width="90" prop="farmStatusView"></el-table-column>
        <el-table-column align="center" label="修改原因" show-overflow-tooltip min-width="90" prop="updateReason"></el-table-column>
        <el-table-column align="center" label="审批状态" resizable min-width="90" prop="auditStatusView"></el-table-column>
        <el-table-column align="center" label="提交人" show-overflow-tooltip min-width="90" prop="submitName"></el-table-column>
        <el-table-column align="center" label="提交时间" show-overflow-tooltip min-width="90" prop="submitDate"></el-table-column>
        <el-table-column align="center" label="审批通过日期" show-overflow-tooltip min-width="120" prop="approvedDate"></el-table-column>
        <el-table-column align="center" label="1方验证审核时间" show-overflow-tooltip min-width="120" prop="onePartyAuditDate"></el-table-column>
        <el-table-column align="center" label="1方验证审核结果" show-overflow-tooltip min-width="120" prop="onePartyAuditResult"></el-table-column>
        <el-table-column align="center" label="1方验证审核报告" show-overflow-tooltip min-width="120">
          <template slot-scope="scope">
            <el-popover placement="right" width="500" trigger="click">
              <el-table :data="scope.row.onePartyAuditReportList">
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column show-overflow-tooltip property="documentName" label="文件名称">
                  <template slot-scope="scope">
                    <el-button @click="onDownload1(scope.row)" type="text" size="small">{{scope.row.documentName}}</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-button type="text" slot="reference">查看</el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column align="center" label="2方验证审核时间" show-overflow-tooltip min-width="120" prop="secondPartyAuditDate"></el-table-column>
        <el-table-column align="center" label="2方验证审核结果" show-overflow-tooltip min-width="120" prop="secondPartyAuditResult"></el-table-column>
        <el-table-column align="center" label="2方验证审核报告" show-overflow-tooltip min-width="120">
          <template slot-scope="scope">
            <el-popover placement="right" width="500" trigger="click">
              <el-table :data="scope.row.secondPartyAuditReportList">
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column show-overflow-tooltip property="documentName" label="文件名称">
                  <template slot-scope="scope">
                    <el-button @click="onDownload2(scope.row)" type="text" size="small">{{scope.row.documentName}}</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-button type="text" slot="reference">查看</el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="更新状态" v-if="dialogUpdateVisible" :visible.sync="dialogUpdateVisible" width="80%" @close="onClose">
      <update-Dialog @onClose="onClose"></update-Dialog>
    </el-dialog>
    <el-dialog title="退回意见" :visible.sync="dialogReturnVisible" width="30%" :close-on-click-modal="false" @close="onCancelReturn" class="fpa">
      <el-form ref="returnForm" :model="returnForm" :rules="returnFormRules">
        <el-form-item prop="returnedReason">
          <el-input v-model="returnForm.returnedReason" type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="center">
        <el-button size="mini" @click="onConfirm" type="primary">确定</el-button>
        <el-button size="mini" @click="onCancelReturn">取消</el-button>
      </el-row>
    </el-dialog>
    <el-dialog title="选择季度" :visible.sync="dialogQuarterVisible" width="30%" :close-on-click-modal="false" @close="onCancelQuarter">
      <quarterDialog ref="quarterDialog" :type="type" @onCancelQuarter="onCancelQuarter"></quarterDialog>
    </el-dialog>
    <el-dialog title="批量导入" :visible.sync="dialogBatchUploadVisible" width="40%" :close-on-click-modal="false" @close="onCloseUpload">
      <el-row style="margin-bottom:10px">
        <el-upload ref="batchUpload" :headers="header" :action="uploadListsUrl" :on-success="uploadListsSuccess" :on-error="uploadError" :on-change="handleChange" :before-upload="beforeListsUpload" :file-list="fileList" :auto-upload="false" :show-file-list="false" style="display:inline-block;margin-right:10px">
          <el-button size="small" type="primary">选取文件</el-button>
        </el-upload>
        <el-link type="button" target="_blank" :href="href" :download="downloadUrl">
          <el-button class="btn" type="primary" size="small" style="height:100%">导入模板下载</el-button>
        </el-link>
      </el-row>
      <el-form :model="uploadForm" ref="uploadForm">
        <el-form-item>
          <el-input v-model="uploadForm.fileName" readonly></el-input>
        </el-form-item>
      </el-form>
      <el-row>
        <h4>说明:</h4>
        <ul>
          <li>1.请点击模板下载,按照模板填写后再上传</li>
          <li>2.模板中红色字段为必填项,请务必正确填写</li>
          <li>3.仅支持上传Excel格式文件,且大小不能超过20M</li>
          <li>4.为保证上传成功,请勿对模板中的单元格进行修改</li>
          <li>5.一次仅支持一份文件上传,多份文件上传将会替换原文件</li>
        </ul>
      </el-row>
      <el-row type="flex" justify="center">
        <el-button size="mini" class="btn" type="primary" @click="onUpload">上传</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onClose1">关闭</el-button>
      </el-row>
    </el-dialog>

  </div>
</template>
<script>
import store from '@/store/index'
import IcSelect from "@/components/common/icSelect";
import rmcProtFarmApi from "@/api/rmcProtein/farm";
import paginationMixin from '@/mixins/pagitionMixin';
import commonFunction from "@/utils/dataTableUtils";
import updateDialog from "./updateDialog.vue"
import { fileService } from "@/api/common/file-utils";
import quarterDialog from "../../Produce/public/quarterDialog.vue"
// import downloadFile from "@/utils/downloadFile";
export default {
  name: 'rmcProtFarm',
  mixins: [paginationMixin],
  components: {
    IcSelect,
    updateDialog,
    quarterDialog,
  },
  data() {
    return {
      multipleSelection: [],
      rmcProteinFarmIds: [],
      category3CodeOptions: [],
      farmNatureOptions: [],
      isInspectedOptions: [
        {
          object: "Y",
          key: "Y"
        },
        {
          object: "N",
          key: "N"
        }
      ],
      breedingModeOptions: [],
      farmStatusOptions: [],
      auditStatusOptions: [],
      tableData: [],
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        category3Code: "",
        sponsorName: '',
        aslGroupName: '',
        farmName: '',
        isInspected: '',
        breedingMode: '',
        farmNature: '',
        farmStatus: 'InUse',
        auditStatus: '',
        farmCode:"",
      },
      uploadForm: {
        fileName: "",
      },
      uploadVertifyForm: {
        fileName: "",
      },
      returnForm: {
        returnedReason: "",
      },
      returnFormRules: {
        returnedReason: [
          { required: true, message: '请输入退回意见', trigger: 'blur' },
        ],
      },
      header: {
        'x-access-token': localStorage.getItem('token')
      },
      isShow: false,
      dialogUpdateVisible: false,
      dialogReturnVisible: false,
      dialogQuarterVisible: false,
      dialogBatchUploadVisible: false,
      dialogVertifyBatchUploadVisible: false,
      totalCount: 0,
      pages: 1,
      ms_roles: null,
      ms_userId: null,
      type: "",
      fileList: [],
      // fileList1: [],
      fileList2: [],
      uploadListsUrl: null,
      href: "",
      downloadUrl: "",
    }
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log('to', to);
    console.log('肉类农场from', from);
    if (from.path === '/qspiTodo' && to.query.sponsorName) {
      to.meta.reqData.sponsorName = to.query.sponsorName
    }
    if (from.path === '/qspiTodo' && to.query.auditStatus) {
      to.meta.reqData.auditStatus = to.query.auditStatus
    }
    if (from.path === '/qspiTodo' && to.query.type && to.query.type !== 'RMC_PROTEIN_FARM_UPDATE') {
      to.meta.reqData.farmStatus = ''
    } else {
      to.meta.reqData.farmStatus = 'InUse'
    }
    // if (from.path === '/rmcProtASL' && to.query.category3Code) {
    //   to.meta.reqData.category3Code = to.query.category3Code
    // }
    // if (from.path === '/rmcProtASL' && to.query.sponsorName) {
    //   to.meta.reqData.sponsorName = to.query.sponsorName
    // }
    if (from.path === '/rmcProtASL' && to.query.aslGroupName) {
      to.meta.reqData.farmStatus = ""
      to.meta.reqData.aslGroupName = to.query.aslGroupName
    }
    rmcProtFarmApi.getFarmData(to.meta.reqData).then((res) => {
      next(vm => {
        vm.queryCondition = to.meta.reqData;
        vm.tableData = res.resultData;
        vm.totalCount = res.totalCount;
      })
    })
  },
  destroyed() {
    this.$store.dispatch('saveQueryData', {})
  },
  computed: {
    // // 导入农场清单
    // uploadListsUrl() {
    //   return process.env.VUE_APP_SERVER_BASE_URL + `rmc/protein/farm/uploadFarmList`;
    // },
    // // 导入验证审核时间/结果
    // uploadUrl1() {
    //   return process.env.VUE_APP_SERVER_BASE_URL + `rmc/protein/farm/uploadFarmAuditList`;
    // },
    // 导入验证审核报告附件
    uploadUrl2() {
      return process.env.VUE_APP_SERVER_BASE_URL + `rmc/protein/farm/uploadPartyAuditReport`;
    },
  },
  created() {
    this.ms_roles = JSON.parse(localStorage.getItem('ms_roles'))
    this.ms_userId = JSON.parse(localStorage.getItem('ms_userId'))
    // console.log('ms_roles', this.ms_roles);
    // console.log('ms_userId', this.ms_userId);
    this.getSelection()
  },
  methods: {
    queryData() {
      rmcProtFarmApi.getFarmData(this.queryCondition).then(res => {
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
        this.rmcProteinFarmIds = []
      });
    },
    getSelection() {
      rmcProtFarmApi.getSelection(['rmc.RmcCategory3', 'rmc.RmcFarmBreedingMode', 'rmc.RmcFarmNature', 'rmc.RmcProteinFarmStatus', 'rmc.RmcAuditStatus']).then(res => {
        console.log('获取下拉框', res);
        this.category3CodeOptions = res.data['rmc.RmcCategory3'].filter((v) => {
          return v.cascadeKey === 'protein'
        })
        this.farmNatureOptions = res.data['rmc.RmcFarmNature'];
        this.breedingModeOptions = res.data['rmc.RmcFarmBreedingMode'];
        this.farmStatusOptions = res.data['rmc.RmcProteinFarmStatus'];
        if (this.ms_roles.indexOf('QSPI_RMC_PROTEIN_CQS') !== -1) {
          this.auditStatusOptions = res.data['rmc.RmcAuditStatus'].filter(ele => {
            return ele.key != "Draft"
          })
        } else {
          this.auditStatusOptions = res.data['rmc.RmcAuditStatus'];
        }
      });
    },
    selectionChange(val) {
      this.multipleSelection = val;
      this.rmcProteinFarmIds = []
      val.forEach(ele => {
        this.rmcProteinFarmIds.push(ele.rmcProteinFarmId)
      })
    },
    onAdd() {
      this.$router.push({
        path: '/rmcProtFarm/detail',
        query: {
          from: 'add',
          rmcProteinFarmId: '0'
        }
      })
    },
    onDel() {
      if (this.rmcProteinFarmIds.length == 0) {
        this.$message.error('请先选择数据后再操作');
        return false
      }
      var flag = this.multipleSelection.every(ele => {
        return ele.auditStatus === 'Draft' || ele.auditStatus === 'Returned'
      })
      if (!flag) {
        this.$message.error("已选中的信息不是草稿或者退回状态，无法删除！");
        return false
      }
      //您确定要删除所选记录吗？
      this.$confirm('请确认是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'colorBtn',
        cancelButtonClass: 'btn_custom_cancel',
        type: 'warning'
      }).then(() => {
        rmcProtFarmApi.deleteFarm({
          rmcProteinFarmIds: this.rmcProteinFarmIds
        }).then(res => {
          console.log('res', res);
          if (res.meta.code === 200) {
            this.$message.success("删除成功");
            this.queryData()
          }
        });
      })
    },
    onSubmit() {
      if (this.rmcProteinFarmIds.length === 0) {
        this.$message.warning("请先选择数据后再操作")
        return false
      }
      var flag = this.multipleSelection.every(ele => {
        return ele.auditStatus !== 'PendingApproval'
      })
      if (!flag) {
        this.$message.warning("页面勾选存在状态为待审批的单据，无法提交！")
        return false
      }
      var flag = this.multipleSelection.some(ele => {
        return !ele.updateReason 
      })
      if (flag) {
        this.$message.warning("页面勾选存在修改原因为空的单据，无法提交！")
        return false
      }
      rmcProtFarmApi.submitBtach({
        rmcProteinFarmIds: this.rmcProteinFarmIds
      }).then(res => {
        if (res.meta.code === 200) {
          this.$message.success('提交成功')
          this.queryData()
        } else {
          this.$message.error(res.meta.msg)
        }
      })
    },
    onVerificationAudit() {
      if (this.rmcProteinFarmIds.length === 0) {
        this.$message.warning("请先选择数据后再操作")
        return false
      }
      if (this.rmcProteinFarmIds.length > 1) {
        this.$message.warning("请仅勾选一家农场进行维护，谢谢.")
        return false
      }
      // sessionStorage.setItem('auditForm', JSON.stringify(this.multipleSelection))
      this.$router.push({
        path: '/rmcProtFarm/auditDetail',
        query: {
          rmcProteinFarmId: this.multipleSelection[0].rmcProteinFarmId,
        }
      })
    },
    onApprove() {
      if (this.rmcProteinFarmIds.length === 0) {
        this.$message.warning("请先选择数据后再操作")
        return false
      }
      var flag = this.multipleSelection.every(ele => {
        return ele.auditStatus == 'PendingApproval'
      })
      if (!flag) {
        this.$message.warning("页面勾选存在状态不为待审批的单据，无法批准！")
        return false
      }
      rmcProtFarmApi.approveFarm({
        rmcProteinFarmIds: this.rmcProteinFarmIds
      }).then(res => {
        if (res.meta.code === 200) {
          this.$message.success('批准成功')
          this.$forceUpdate()
          this.queryData()
        } else {
          this.$message.error(res.meta.msg)
        }
      })
    },
    onReturn() {
      if (this.rmcProteinFarmIds.length === 0) {
        this.$message.warning("请先选择数据后再操作")
        return false
      }
      var flag = this.multipleSelection.every(ele => {
        return ele.auditStatus == 'PendingApproval'
      })
      if (!flag) {
        this.$message.warning("页面勾选存在状态不为待审批的单据，无法退回！")
        return false
      }
      this.dialogReturnVisible = true
    },
    onConfirm() {
      this.$refs['returnForm'].validate((valid) => {
        if (valid) {
          rmcProtFarmApi.returnFarm({
            rmcProteinFarmIds: this.rmcProteinFarmIds,
            returnedReason: this.returnForm.returnedReason
          }).then(res => {
            if (res.meta.code === 200) {
              this.$message.success('退回成功')
              this.dialogReturnVisible = false
              this.queryData()
            } else {
              this.$message.error(res.meta.msg)
            }
          })
        }
      })
    },
    onCancelReturn() {
      this.dialogReturnVisible = false
      this.returnForm.returnedReason = ''
    },
    confirmIsUpdate() {
      rmcProtFarmApi.confirmNoChange().then(res => {
        if (res.meta.code === 200) {
          this.$message.success(res.data)
          this.queryData()
        } else {
          this.$message.error(res.meta.msg)
        }
      })
    },
    downloadFarm() {
      this.$set(this.queryCondition, 'rmcProteinFarmIds', this.rmcProteinFarmIds)
      rmcProtFarmApi.downloadFarmLists(this.queryCondition).then(res => {
        fileService.respToFile(res, 'Protein_农场清单.xlsx');
        this.$set(this.queryCondition, 'rmcProteinFarmIds', [])
      })
    },
    downloadFarmQuarter() {
      this.dialogQuarterVisible = true
      this.type = "protein_farm"
      this.$refs['quarterDialog'].$refs['quarterForm'].clearValidate()
    },
    onCancelQuarter() {
      this.dialogQuarterVisible = false
      this.$refs['quarterDialog'].$refs['quarterForm'].resetFields()
    },
    // beforeUpload1(file) {
    //   console.log('file', file);
    //   // var isZip = true
    //   // if (file.type == "application/x-zip-compressed") {
    //   //   isZip = true
    //   // } else {
    //   //   isZip = false
    //   // }
    //   const isLt50M = file.size / 1024 / 1024 < 50;
    //   // if (!isZip) {
    //   //   this.$message.error('请批量打包成ZIP包后上传');
    //   // }
    //   if (!isLt50M) {
    //     this.$message.error('附件大小不得超过50M');
    //   }
    //   return isLt50M;
    // },
    // uploadSuccess1(resp) {
    //   console.log('resp', resp);
    //   if (resp.code == 200) {
    //     this.$message.success(this.$t("common.UploadSucceed"));
    //     this.queryData();
    //   } else {
    //     this.$message.error(resp.msg);
    //   }
    //     this.fileList1 = []
    //     this.$refs.upload1.clearFiles();
    // },
    beforeUpload2(file) {
      console.log('file', file);
      var isZip = true
      if (file.type == "application/x-zip-compressed") {
        isZip = true
      } else {
        isZip = false
      }
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isZip) {
        this.$message.error('请批量打包成ZIP包后上传');
      }
      if (!isLt50M) {
        this.$message.error('附件大小不得超过50M');
      }
      return isZip && isLt50M;
    },
    uploadSuccess2(resp) {
      console.log('resp', resp);
      if (resp.code == 200) {
        this.$message.success(this.$t("common.UploadSucceed"));
        this.queryData();
      } else {
        this.$message.error(resp.msg);
      }
      this.fileList2 = []
      this.$refs.upload2.clearFiles();
    },
    uploadError(resp) {
      console.log('resp', resp);
      if (undefined != resp.message) {
        let res = JSON.parse(resp.message);
        this.$message.error(res.msg);
      } else {
        this.$message.error("文件上传失败,请检查后重试！");
      }
    },
    onBatchUpload() {
      this.dialogBatchUploadVisible = true
      this.uploadForm.fileName = ''
      this.fileList = []
      this.uploadListsUrl = process.env.VUE_APP_SERVER_BASE_URL + `rmc/protein/farm/uploadFarmList`
      this.href = "static/template/qspi/RMC_Protein_农场清单批量导入模板.xlsx"
      this.downloadUrl = "RMC_Protein_农场清单批量导入模板.xlsx"
      console.log('uploadListsUrl1', this.uploadListsUrl);
      console.log('href1', this.href);
      console.log('downloadUrl1', this.downloadUrl);
    },
    onBatchUploadVertify() {
      this.dialogBatchUploadVisible = true
      this.uploadForm.fileName = ''
      this.fileList = []
      this.uploadListsUrl = process.env.VUE_APP_SERVER_BASE_URL + `rmc/protein/farm/uploadFarmAuditList`
      this.href = "static/template/qspi/RMC_Protein_农场清单验证审核结果导入模板.xlsx"
      this.downloadUrl = "RMC_Protein_农场清单验证审核结果导入模板.xlsx"
      console.log('uploadListsUrl2', this.uploadListsUrl);
      console.log('href2', this.href);
      console.log('downloadUrl2', this.downloadUrl);
    },
    handleChange(file, fileList) {
      console.log('file', file);
      console.log('fileList', fileList);
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]]  // 这一步，是 展示最后一次选择的csv文件
      }
      this.uploadForm.fileName = file.name
    },
    beforeListsUpload(file) {
      console.log('beforeUpload', file);
      var isExcel = true
      if (file.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || file.type == "application/vnd.ms-excel") {
        isExcel = true
      } else {
        isExcel = false
      }
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isExcel) {
        this.$my_message('请选择Excel文件上传', 'error');
      }
      if (!isLt50M) {
        this.$my_message('附件大小不得超过50M', 'error');
      }
      return isExcel && isLt50M;
    },
    uploadListsSuccess(resp) {
      console.log('resp', resp);
      var data = resp.data.split(',')
      console.log('data', data);
      var successNum = Number(data[0].split('{')[1].split(':')[1])
      console.log('successNum', successNum);
      var errorNum = Number(data[1].split('}')[0].split(':')[1])
      console.log('errorNum', errorNum);
      var total = Number(successNum + errorNum)
      this.dialogBatchUploadVisible = false
      this.fileList = []
      this.uploadForm.fileName = ''
      if (resp.meta.code == 200) {
        this.$message.success('您已成功导入数据' + successNum + '条');
        this.queryData();
      } else {
        console.log('resp.meta.msg', resp.meta.msg);
        var totalText = '导入文件数据共 ' + total + ' 条'
        var successText = '满足导入条件: ' + successNum + ' 条'
        var errorText = '不满足导入条件: ' + errorNum + ' 条'
        var sumText = '如果存在导入失败的数据,请导出失败原因,修改后再重新上传'
        const wordText = [totalText, successText, errorText, sumText]
        var newArr = []
        const h = this.$createElement;
        for (const i in wordText) {
          newArr.push(h('p', null, wordText[i]))
        }
        this.$confirm('导入结果', {
          title: '导入结果',
          message: h('div', null, newArr),
          showCancelButton: true,
          confirmButtonText: '导出失败原因',
          confirmButtonClass: "confirmButtonClass",
          cancelButtonClass: "cancelButtonClass",
          cancelButtonText: '取消',
          customClass: "uploadBtn",
          type: 'warning'
        }).then(() => {
          let str = new Blob([resp.meta.msg], { type: 'text/plain;charset=utf-8' })
          saveAs(str, '导入失败原因报表.txt')
        }).catch(() => {
          this.$message.info('已取消导出失败原因')
        })
      }
      this.$refs.batchUpload.clearFiles();
    },
    onUpload() {
      this.$refs.batchUpload.submit();
    },
    onClose1() {
      this.dialogBatchUploadVisible = false
      this.uploadForm.fileName = ''
      this.fileList = []
    },
    onUpdateLog() {
      this.dialogUpdateVisible = true
    },
    downloadAuditReport() {
      if (this.rmcProteinFarmIds.length === 0) {
        this.$message.warning("请先选择数据后再操作")
        return false
      }
      rmcProtFarmApi.downloadPartyAuditReport({
        rmcProteinFarmIds: this.rmcProteinFarmIds
      }).then(res => {
        fileService.respToFile(res, 'Protein_农场清单_验证审核报告.zip');
      });
    },
    onDetail(row) {
      this.$router.push({
        path: '/rmcProtFarm/detail',
        query: {
          rmcProteinFarmId: row.rmcProteinFarmId,
          from: 'edit'
        }
      })
    },
    onDownload1(row) {
      console.log('row', row);
      fileService.downloadFile(row).then((res) => {
        fileService.respToFile(res, row.documentName);
      })
    },
    onDownload2(row) {
      console.log('row', row);
      fileService.downloadFile(row).then((res) => {
        fileService.respToFile(res, row.documentName);
      })
    },
    onClose() {
      this.dialogUpdateVisible = false
      this.queryData()
    },
    onSearch() {
      this.queryCondition.pageNum = 1
      this.queryCondition.pageSize = 15
      this.queryData()
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    onReset() {
      this.$refs['queryCondition'].resetFields()
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        category3Code: "",
        sponsorName: '',
        aslGroupName: '',
        farmName: '',
        isInspected: '',
        breedingMode: '',
        farmNature: '',
        farmStatus: '',
        auditStatus: ''
      }
      this.rmcProteinFarmIds = []
      this.queryData();
    },
  },
  extends: commonFunction
}
</script>
<style scoped >
</style>
